import idsTokens from './utils/tokens/idsTokens';

// Theme colors
export const primary = '#0768fd'; // rgb(7, 104, 253)
export const primaryDark = '#0557d5'; // rgb(5, 87, 213)
export const primaryLight = '#ecf3ff'; // rgb(236, 243, 255)

// New theme color names
export const neptunePrimary = primary;
export const neptunePrimaryDark = primaryDark;
export const neptunePrimaryLight = primaryLight;

// Deprecated
export const primaryHover = primaryLight;
export const primaryHoverTransparent = 'rgba(35, 114, 253, 0.08)';
export const primaryHoverDark = primaryDark; // rgb(5, 87, 213)

// Transparencies
export const transparentLight = 'rgba(255, 255, 255, 0.16)';
export const transparent = 'rgba(255, 255, 255, 0.24)';
export const primaryLightTransparent = primaryHoverTransparent;

// New transparency name
export const neptunePrimaryLightTransparent = primaryLightTransparent;

// Background colors
export const white = '#ffffff'; // rgb(255, 255, 255)
export const neutral1 = '#f8f9fb'; // rgb(248, 249, 251)

// Neutral colors
export const neutral2 = '#f2f2f2'; // rgb(242, 242, 242)
export const neutral3 = '#e9e9e9'; // rgb(233, 233, 233)
export const neutral4 = '#d9d9d9'; // rgb(217, 217, 217)
export const neutral5 = '#b5b5b5'; // rgb(181, 181, 181)
export const neutral6 = '#999999'; // rgb(153, 153, 153)
export const neutral7 = '#595959'; // rgb(89, 89, 89)
export const neutral8 = '#444444'; // rgb(68, 68, 68)
export const neutral9 = '#393939'; // rgb(57, 57, 57)
export const black = '#000000'; // rgb(0, 0, 0)

// Utility colors
export const green = '#00c221'; // rgb(0, 194, 33)
export const orange = '#ff9300'; // rgb(255, 147, 0)
export const red = '#e20000'; // rgb(226, 0, 0)
export const grey = '#333333'; // rgb(51, 51, 51)

// Data visualization colors
export const purple = '#9e54b0'; // rgb(158, 84, 176)
export const blue = '#076bfd'; // rgb(7, 107, 253)
export const fuchsia = '#df216d'; // rgb(223, 33, 109)
export const blueDark = '#10558a'; // rgb(16, 85, 138)
export const dataVizColors = [purple, blue, orange, fuchsia, green, blueDark];

// Variations used in palette
export const primaryLight2 = '#83b4fe'; // rgb(131, 180, 254)
export const primaryDark2 = '#0555fc'; // rgb(5, 85, 252)
export const primaryDivider = '#e1edff'; // rgb(225, 237, 255)
export const secondary = '#0076ae'; // rgb(0, 118, 174)
export const secondaryLight = '#80bbd7'; // rgb(128, 187, 215)
export const secondaryDark = '#00639d'; // rgb(0, 99, 157)
export const redVeryLight = '#fef3f3'; // rgb(254,243,243)
export const redLight = '#f18080'; // rgb(241, 128, 128)
export const redDark = '#c50404'; // rgb(197, 4, 4)

// Updated to 'Neutral' palette
export const themeGrey = {
  50: white,
  100: neutral1,
  200: neutral2,
  300: neutral3,
  400: neutral4,
  500: neutral5,
  600: neutral6,
  700: neutral7,
  800: neutral8,
  900: black,
  A100: '#f4f7fd', // rgb(244, 247, 253)
  A200: '#dfe3eb', // rgb(223, 227, 235)
  A400: '#c8cbd1', // rgb(200, 203, 209)
  A700: '#a6aab2', // rgb(166, 170, 178)
  contrastDefaultColor: 'light',
  hover: '#dddddd', // rgb(221, 221, 221)
};

export const gradientStart = '#250056'; // rgb(37, 0, 86)
export const gradientHorizontal = `linear-gradient(to right, ${gradientStart}, ${secondary})`;

export const gradientStartBrand = idsTokens.functional.color.surface.container.gradient.brand.start;
export const gradientEndBrand = idsTokens.functional.color.surface.container.gradient.brand.end;
export const gradientStartAccent =
  idsTokens.functional.color.surface.container.gradient.accent.start;
export const gradientEndAccent = idsTokens.functional.color.surface.container.gradient.accent.end;
export const gradientStartNeutral =
  idsTokens.functional.color.surface.container.gradient.neutral.start;
export const gradientEndNeutral = idsTokens.functional.color.surface.container.gradient.neutral.end;
export const gradientStartInverse =
  idsTokens.functional.color.surface.container.gradient.neutralInverse.start;
export const gradientEndInverse =
  idsTokens.functional.color.surface.container.gradient.neutralInverse.end;

// New gradient name
export const neptuneGradient = gradientHorizontal;

// Horizontal gradients
export const gradientHorizontalBrand = `linear-gradient(to right, ${gradientStartBrand}, ${gradientEndBrand})`;
export const gradientHorizontalAccent = `linear-gradient(to right, ${gradientStartAccent}, ${gradientEndAccent})`;
export const gradientHorizontalNeutral = `linear-gradient(to right, ${gradientStartNeutral}, ${gradientEndNeutral})`;
export const gradientHorizontalInverse = `linear-gradient(to right, ${gradientStartInverse}, ${gradientEndInverse})`;

// Vertical gradients
export const gradientVerticalBrand = `linear-gradient(to bottom, ${gradientStartBrand}, ${gradientEndBrand})`;
export const gradientVerticalAccent = `linear-gradient(to bottom, ${gradientStartAccent}, ${gradientEndAccent})`;
export const gradientVerticalNeutral = `linear-gradient(to bottom, ${gradientStartNeutral}, ${gradientEndNeutral})`;
export const gradientVerticalInverse = `linear-gradient(to bottom, ${gradientStartInverse}, ${gradientEndInverse})`;

// Color aliases
export const utilityNegative = red;
export const utilityWarning = orange;
export const utilityPositive = green;
export const utilityInfo = primary;

export const bannerSuccess = '#00A21B';
export const bannerWarning = '#D67B00';
export const bannerError = '#BD0000';
